import {Record} from 'immutable';
import {handleActions} from 'redux-actions';

import * as DiscountPresetActions from 'web-app/react/entities/discounts/presets/actions';

const DiscountPresetState = Record({
    loadingPresets: false,
});

export default handleActions(
    {
        [DiscountPresetActions.fetchAllPresets.type]: state =>
            state.merge({
                loadingPresets: true,
            }),
        [DiscountPresetActions.fetchAllPresetsSuccess.type]: state =>
            state.merge({
                loadingPresets: false,
            }),
        [DiscountPresetActions.updatePresets.type]: state =>
            state.merge({
                loadingPresets: true,
            }),
        [DiscountPresetActions.updatePresetsSuccess.type]: state =>
            state.merge({
                loadingPresets: false,
            }),
    },
    new DiscountPresetState(),
);
